import {
  AuthHeader,
} from './AuthHeader'

import {
  GuestHeader,
} from './GuestHeader'

import type {
  AuthStatus,
} from '../../hooks/useHeader'

import type {
  HeaderResponse,
} from '../../types/header'

import type {
  MeResponse,
} from '../../types/me'

interface HeaderProps {
  status: AuthStatus
  me: MeResponse | null
  header: HeaderResponse | null
  error: string | null
  onRetry: () => Promise<void>
}

export function Header({
  status,
  me,
  header,
  error,
  onRetry,
}: HeaderProps) {
  if (status === 'checking') {
    return <HeaderSkeleton />
  }

  if (
    status === 'authenticated' &&
    me &&
    header
  ) {
    return (
      <AuthHeader
        me={me}
        header={header}
      />
    )
  }

  if (status === 'guest') {
    return <GuestHeader />
  }

  return (
    <header className="kr-header">
      <div className="kr-header__inner">
        <a
          href="/"
          className="kr-header__brand kr-header__brand--logo"
          aria-label="Kraken Academy"
        >
          <img
            className="kr-header__logo"
            src="https://jjrr9e9l0o.cdn.twcstorage.ru/headers/logo.webp"
            alt="Kraken Academy"
          />
        </a>

        <div className="kr-header-error">
          <span>
            {error ??
              'Не удалось загрузить Академию'}
          </span>

          <button
            type="button"
            onClick={() => {
              void onRetry()
            }}
          >
            Повторить
          </button>
        </div>
      </div>
    </header>
  )
}

function HeaderSkeleton() {
  return (
    <header className="kr-header">
      <div className="kr-header__inner">
        <div className="kr-header-skeleton__logo" />

        <div className="kr-header-skeleton__nav">
          <span />
          <span />
          <span />
        </div>

        <div className="kr-header-skeleton__user" />
      </div>
    </header>
  )
}
